export default "__VITE_ASSET__C7HreLj6__"